import { createNamespace, Actions } from "../../../../../flux/index";
import { VehicleGeoposition } from "../../../../../rest/GetVehiclesGeoposition";

const ns = createNamespace('VehicleGeoposition');
export const names = {
    SET_VEHICLES: ns('SET_VEHICLES'),
    CLEAR: ns('CLEAR'),
};

export class VehicleGeopositionActions extends Actions
{
    setVehicleGeoposition = (vehiclesLocations: VehicleGeoposition[]) => this.dispatch(names.SET_VEHICLES, vehiclesLocations);
    clear = () => this.dispatch(names.CLEAR);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/flux/VehicleGeopositionActions.ts